<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    if (window.localStorage.getItem('userId')) {
      this.$getAddressData() // 获取地区编码
    }
  }
};
</script>

<style>
/* 全局公共样式 */
@import url("./assets/css/normalize.css");
@import url("./assets/css/base.css");
@import url("./assets/icon/iconfont.css");

* {
  padding: 0;
  margin: 0;
}

body,
html {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 500px;
}

/* body{
  padding-right: 0px !important;
  overflow: hidden;
} */
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c2c2c;
  width: 100%;
  height: 100%;
}

/* 定义可变必填项的*号标识 */
.el-form-required-true .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

/* 定义商品控销标签样式 */
.my-el-tag {
  display: inline-block;
  height: 32px !important;
  margin-right: 5px;
  font-size: 14px;
  line-height: 32px !important;
  text-align: center;
}

/**说明书 */
.explain-text {
  height: 500px;
  text-indent: 2em;
  line-height: 28px;
}
</style>
